import { render, staticRenderFns } from "./newsListMobile.vue?vue&type=template&id=70dda055&scoped=true"
import script from "./newsListMobile.vue?vue&type=script&lang=js"
export * from "./newsListMobile.vue?vue&type=script&lang=js"
import style0 from "./newsListMobile.vue?vue&type=style&index=0&id=70dda055&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dda055",
  null
  
)

export default component.exports